import type { DefaultRootState as ReactReduxDefaultRootState } from "react-redux";
import { combineReducers } from "redux";
import brandMenu from "reducers/brand_menu";

import context from "reducers/context";
import olo from "reducers/olo";
import superUser, { type ISuperUserState } from "reducers/super_user";
import user, { type IUserState } from "reducers/user";
import users from "reducers/users";

import type { IBrandMenuState } from "types/brand_menu";
import type { IContext } from "types/context";
import type { IOLOState } from "types/olo";
import type { IUsers } from "types/user";

declare module "react-redux" {
  interface DefaultRootState {
    brandMenu: IBrandMenuState;
    context: IContext;
    olo: IOLOState;
    user: IUserState;
    users: IUsers;
    superUser: ISuperUserState;
  }
}

const reducers = combineReducers<ReactReduxDefaultRootState>({
  brandMenu,
  context,
  olo,
  user,
  users,
  superUser,
});

export default reducers;
